import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/PodcastsPage.vue"),
    meta: {
      title: "Podcasts",
    },
    name: "podcasts",
    path: "/podcasts",
    props: (route) => typecastRouteProps(route),
  },
  {
    component: () => import("pages/PodcastEdit.vue"),
    meta: {
      title: "New Podcast",
    },
    name: "podcasts-new",
    path: "/podcasts/new",
    props: true,
  },
  {
    component: () => import("pages/PodcastEdit.vue"),
    meta: {
      title: "Edit Podcast",
    },
    name: "podcasts-edit",
    path: "/podcasts/:id/edit",
    props: true,
  },
];
